module.exports = __webpack_public_path__ + "img/new-survey-header.0ae51c51.png";